<div style="display: inline-block;">
    Ventas - Dia Semana
    <epy-tooltip placement="top" style="width: 18px;display: inline-block;">
        <span class="difference" slot="trigger">
            <i class="fa fa-info-circle info" aria-hidden="true"></i>
        </span>
        Ventas de las ultimas 4 semanas.
    </epy-tooltip>
</div>
<div class="flex-item" *ngIf="reqst===2">
    <div class="graphic">
        <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions"
            [ngStyle]="{ height: section ? '350px' : '320px', width: '100%', display: 'block', overflow: 'hidden' }"></highcharts-chart>
    </div>
</div>
<div *ngIf="reqst===1" class="text-center loader-container">
    <div class="spinner-grow align-middle text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<ng-template #editModal let-modal class="modal-dialog big-dialog">
    <div class="modal-header" #tableModal>
        <h5 class="modal-title" id="downloadPricesLabel">
        </h5>
        <button type="button" class="close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding-top: 0;">
        <app-table-alerts></app-table-alerts>
    </div>
    <div class="footer-modal" style="padding-top: 0;">

    </div>
</ng-template>